import React from 'react'
// import Stack from '@mui/material/Stack';
// import CircularProgress from '@mui/material/CircularProgress';
import Loader from '../../Assets/images/spinner.png';
import Backdrop from '@mui/material/Backdrop';
const Spinner = () => {
    return (
        <>
            {/* <Stack className='spinner' sx={{ color: 'grey.500' }} spacing={2} direction="row">
                <CircularProgress color="inherit" />
            </Stack> */}
            <div>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open >
          <div className="d-flex justify-content-center align-item-center spinner">
            <div className="loading">
              <div className="loading__ring1 ">
                <img src={Loader} className='loaderImg' height="50px" width="50px" alt="" />
              </div>
              <div class="loading__ring2">
                <img src={Loader} className='loaderImg' height="50px" width="50px" alt="" />
              </div>
            </div>          
          </div>
        </Backdrop>
      </div>
        </>
    )
}

export default Spinner
